<template>
  <div id="GoTop" @click="handleGoTop" :class="{ 'go-top-active': isAnimating }" v-show="showGoTop">
    <span class="glyphicon glyphicon-chevron-up"></span>
  </div>
</template>

<script>
export default {
  name: 'GoTop',
  data() {
    return {
      showGoTop: false, // 控制按钮显示隐藏
      isAnimating: false, // 动画状态标记（防止重复点击）
      scrollAnimationFrame: null, // 存储动画帧ID用于中断
      scrollHandler: null // 存储滚动监听函数用于销毁
    }
  },
  mounted() {
    // 监听滚动事件控制按钮显示（带防抖优化）
    this.scrollHandler = this.debounce(() => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      this.showGoTop = scrollTop > 150 // 滚动超过150px显示按钮（可调整）
    }, 50)

    window.addEventListener('scroll', this.scrollHandler)
  },
  beforeDestroy() {
    // 移除事件监听防止内存泄漏
    window.removeEventListener('scroll', this.scrollHandler)
    // 中断未完成的滚动动画
    cancelAnimationFrame(this.scrollAnimationFrame)
  },
  methods: {
    Show() {
      this.showGoTo = !this.showGoTop
    },
    // 点击处理函数
    handleGoTop() {
      if (this.isAnimating) return // 动画进行中禁止重复触发

      this.isAnimating = true
      this.smoothScrollToTop({
        duration: 1000, // 总滚动时间（1秒更慢更平滑）
        easing: 'easeOutQuad' // 缓动函数（先快后慢）
      })
    },

    // 核心平滑滚动方法（支持配置参数）
    smoothScrollToTop(options) {
      const { duration = 800, easing = 'easeInOutQuad' } = options
      const startScroll = window.pageYOffset || document.documentElement.scrollTop
      const startTime = performance.now()

      // 常用缓动函数集合（可根据需求替换）
      const easingFunctions = {
        linear: t => t,
        easeInQuad: t => t * t,
        easeOutQuad: t => t * (2 - t), // 先快后慢（更符合"慢慢停下"的需求）
        easeInOutQuad: t => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2)
      }

      // 动画执行函数
      const animate = currentTime => {
        const timeElapsed = currentTime - startTime
        const progress = Math.min(timeElapsed / duration, 1)
        const easeProgress = easingFunctions[easing](progress)

        // 计算当前滚动位置（关键公式）
        const currentScroll = startScroll - startScroll * easeProgress
        window.scrollTo(0, currentScroll)

        // 滚动未完成时继续下一帧
        if (timeElapsed < duration) {
          this.scrollAnimationFrame = requestAnimationFrame(animate)
        } else {
          // 最终确保到达顶部（处理可能的计算误差）
          window.scrollTo(0, 0)
          this.isAnimating = false
        }
      }

      // 启动动画
      this.scrollAnimationFrame = requestAnimationFrame(animate)
    },

    // 防抖函数（优化滚动监听性能）
    debounce(fn, delay = 100) {
      let timer = null
      return () => {
        if (timer) clearTimeout(timer)
        timer = setTimeout(() => fn.apply(this, arguments), delay)
      }
    }
  }
}
</script>
<style scoped>
#GoTop {
  position: fixed;
  bottom: 0.4rem;
  right: 0.09rem;
  width: 3em;
  height: 3em;
  z-index: 2147483647;
  cursor: pointer;
}

#GoTop > span {
  display: block;
  width: 100%;
  height: 100%;
  color: #f18800;
  font-size: 2em;
  transition: opacity 0.2s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue